import { useQuery } from '@tanstack/react-query';
import { MeApi } from 'src/api';
import { ONE_MINUTE } from 'src/constants/times.const';

export const dailyNewWordsKey = (languagePairId: number) =>
  ['dailyNewWords', languagePairId] as const;

/** The learner's daily new-words goal and how many new words they started today. */
export const useDailyNewWords = (languagePairId: number | null | undefined, enabled = true) =>
  useQuery({
    queryKey: dailyNewWordsKey(languagePairId as number),
    queryFn: () => MeApi.getDailyNewWords(languagePairId as number),
    enabled: enabled && !!languagePairId,
    staleTime: ONE_MINUTE,
  });
